module.exports = __webpack_public_path__ + "static/media/attack-5.884ef555.png";